export default __webpack_public_path__ + "source-sans-pro-v13-latin_latin-ext-700.e7cfe2ca0e4a2f2caf7b.woff2";